<template>
  <yes-no-modal
    text="Are you sure you want to logout?"
    @back="$emit('back')"
    @submit="logoutUser"
  />
</template>

<script>
import { logout } from "Adapters/ApiAdapter/user";
import YesNoModal from "Components/Public/YesNoModal";
import { ROUTE_LOGIN } from "Consts/publicRoutes";

export default {
  name: "LogoutModal",
  components: { YesNoModal },
  methods: {
    async logoutUser() {
      await logout();
      await this.$router.push({
        name: ROUTE_LOGIN,
      });
    },
  },
};
</script>

<style scoped></style>
